<template>
  <List :mapState="'inventoryProducts'" :allDispatch="'inventoryProductsAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/inventory/products/list.vue